import React from "react"
import styled from "styled-components"

import { Box, Flex } from "components/box"
import { Paragraph, ParagraphLarge, LinkWithArrow } from "components/text"

const Container = styled(Flex).attrs({
  flexDirection: ["column", "column", "row"],
  py: 7,
  px: [0, 0, 7],
  bg: "iceBlue"
})`
  justify-content: center;
  align-items: center;
`

type Props = {
  headline: string
  body: string
  linkText: string
  to: string
  icon?: React.ReactNode
}

const LinkArticle = ({ headline, body, linkText, to, icon }: Props) => (
  <Container>
    {icon && (
      <Box mr={[0, 0, 6, 6]} mb={[6, 6, 0, 0]}>
        {icon}
      </Box>
    )}
    <Box textAlign={["center", "center", "left"]}>
      <ParagraphLarge bold>{headline}</ParagraphLarge>
      <Paragraph>{body}</Paragraph>
      <LinkWithArrow mt={2} to={to} color="evergreen">
        {linkText}
      </LinkWithArrow>
    </Box>
  </Container>
)

export default LinkArticle
